import { categoryTone } from '../communications/categories';

// Shared "Communications by category" bar row - used by both the
// practice-scoped CommunicationsByCategoryCard here and the Accounts
// Overview hub's global variant
// (src/components/accounts/overview/HubCategoryCard.tsx), so the bar chrome
// and the category tone map (categories.ts) each have exactly one home.
export function CategoryBarRowSkeleton() {
    return (
        <div className="flex items-center gap-3">
            <div className="w-[112px] h-3 rounded bg-gray-100 animate-pulse shrink-0" />
            <div className="flex-1 h-2 rounded-full bg-gray-100 animate-pulse" />
            <div className="w-6 h-3 rounded bg-gray-100 animate-pulse shrink-0" />
        </div>
    );
}

interface CategoryBarRowProps {
    category: string;
    count: number;
    maxCount: number;
}

export function CategoryBarRow({ category, count, maxCount }: CategoryBarRowProps) {
    const pct = maxCount > 0 ? Math.round((count / maxCount) * 100) : 0;
    return (
        <div className="flex items-center gap-3">
            <span className="w-[112px] text-[12px] font-medium text-gray-600 text-left truncate">
                {category}
            </span>
            <div className="flex-1 h-2 rounded-full bg-gray-100 overflow-hidden">
                <div
                    className="h-full rounded-full"
                    style={{ width: `${pct}%`, background: categoryTone(category) }}
                />
            </div>
            <span className="w-6 text-[12px] font-semibold text-gray-700 tabular-nums text-right">
                {count}
            </span>
        </div>
    );
}
